
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";
import MassUploadTool from './MassUploadTool';

const MassUploadTab = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Mass Upload Content</CardTitle>
        <CardDescription>
          Upload and manage content in bulk by importing a spreadsheet.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <MassUploadTool />
      </CardContent>
      <CardFooter className="flex justify-start pt-0">
        <Button 
          variant="outline" 
          size="sm" 
          className="text-xs" 
          asChild
        >
          <a href="/lesson_template.csv" download>
            <FileDown className="mr-2 h-3.5 w-3.5" />
            Download Template
          </a>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default MassUploadTab;
